import * as React from "react";

// importing material UI components
import { useState } from "react";
import OrdersListTable from "./OrdersListTable";
import Container from "@mui/material/Container";

const Orders = (props) => {
  return (
    <div className="App">
      {/* <h2 className="heading-title">Orders</h2> */}
      <OrdersListTable
        refreshkey={props.refreshKey}
        onNavigate={props.onNavigate}
      />
    </div>
  );
};
export default Orders;
